import { ButtonType } from '@/types/components';
import { cn } from '@/utils/cn';
import { Loader } from './Loader';

interface ButtonProps {
  type: ButtonType;
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
}

const whiteButtonClassNames = cn(
  'bg-white rounded-lg p-2 flex flex-row justify-center items-center text-base-black border-1 border-base-border'
);
const blackButtonClassNames = cn('bg-base-black rounded-lg p-2 flex flex-row justify-center items-center text-white');
const successButtonClassNames = cn('bg-green-600 rounded-lg p-2 flex flex-row justify-center items-center text-white');
const blueButtonClassNames = cn('bg-[#448AE3] rounded-lg p-2 flex flex-row justify-center items-center text-white');

export const Button = ({ type, children, onClick, className, isLoading = false, disabled = false }: ButtonProps) => {
  const isDisabled = disabled || isLoading;

  const getButtonClassNames = () => {
    switch (type) {
      case ButtonType.BLUE:
        return blueButtonClassNames;
      case ButtonType.SUCCESS:
        return successButtonClassNames;
      case ButtonType.DARK:
        return blackButtonClassNames;
      default:
        return whiteButtonClassNames;
    }
  };

  return (
    <div
      className={cn(
        getButtonClassNames(),
        'w-full h-11',
        className,
        isDisabled ? 'opacity-50 cursor-not-allowed' : 'md:cursor-pointer'
      )}
      onClick={isDisabled ? undefined : onClick}
    >
      {isLoading ? <Loader size="xs" color={type === ButtonType.DARK ? 'white' : 'blue'} /> : children}
    </div>
  );
};
